import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import WorshipLocationDetailsComponent from '../../components/WorshipLocationDetails';
import { getWorshipLocationByIdRequest } from '../../actionCreators/worshipLocationsActions';
import { addAlertToAlertsList } from '../../actionCreators/globalAlerts';

import { RESET_WORSHIP_LOCATION_BY_ID_SUCCESS } from '../../constants/actionTypes';

const WorshipLocationDetails = (props) => <WorshipLocationDetailsComponent {...props} />;

const WorshipLocationDetailsContainer = (props) => {
  const state = useSelector((state) => ({
    worshipLocations: state.worshipLocations.worshipLocationsList,
    currentWorshipLocation: state.worshipLocations.currentWorshipLocation,
    currentUser: state.currentUser.userData,
  }));

  const dispatch = useDispatch();

  const actions = {
    addAlertToAlerts: payload => dispatch(addAlertToAlertsList(payload)),
    getWorshipLocationByid: (payload) => dispatch(getWorshipLocationByIdRequest(payload)),
    resetWorshipLocationsByid: () =>
      dispatch({
        type: RESET_WORSHIP_LOCATION_BY_ID_SUCCESS,
        payload: '',
      }),
  };

  return <WorshipLocationDetails {...props} {...state} {...actions} />;
};

export default WorshipLocationDetailsContainer;
